<quill-editor
  #editor
  [readOnly]="disabled"
  [modules]="editorModules"
  placeholder=""
  class="editor"
  [ngModel]="data"
  (ngModelChange)="onModelChange($event)"
  (onEditorCreated)="onEditorCreated()"
[styles]="getEditorStyles()"></quill-editor>
@if (maxChars) {
  <p [class.max-chars-reached]="charCount > maxChars">
    Number of characters: {{ charCount }}/{{ maxChars }}
  </p>
}
